// src/routes/AppLayout/AppLayout.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import Navbarlanding from "../../components/Navbarlanding";

import MobileBottomNav from "../../components/common/MobileBottomNav";

const noNavbarFooterPaths = [
  "/login",
  "/builder/consultant",
  "/builder/consultant-profile-create",
  "/builder/consultant-profile-subscription",
  "/builder/consultant-profile-subscription-history",
  "/", // ensu
  "/builder/erp",
  "/builder/consultant-profiles",
  "/joinus",
  "/agent/real-estate",
  "//",
  "/consultant/dashboard",
  "/consultant/login",
  "/consultant/signup",
  "/consultant/subscription",
  "/consultant/subscription-history",
  "/builder/projects",
  "/builder/real-estate",
  "/builder/housing-plot",
  "/builder/housingplot",
  "/agent/subscription",
  "/agent/notification",
  "/agent/housingpost",
  "/agent/propertypost",
  "/agent/customerquery",
  "/builder/notification",
  "/builder/projectenquiry",
  // "/builder/chat", // This was already removed
  // "/builder/payment", // Generic payment path, will be replaced by project specific
  "/builder/housingplot",
  "/agent/subscription",
  "/agent/notification",
  "/agent/housingpost",
  "/agent/propertypost",
  "/agent/customerquery",
  "/builder/notification",
  "/builder/projectenquiry",
  // "/builder/chat", // This was already removed
  // "/builder/payment", // Generic payment path, will be replaced by project specific
  "/builder/subscriptionhistory",
  "/builder/subscription",
  "/builder/customerenquiry",
  "/builder/profile",
  "/builder/support",
  "/builder/profilecard",
  "/builder/dashboard",
  "/builder/plot",
  "/builder/jobs", // Added from previous changes
  "/builder/project-incharge",
  "/customer/rejectcard",
  "/customer/project/:projectId/payment",
  // "/customer/chatbox", // This was already removed
  "/customer/paymenthistory",
  "/customer/help",
  "/customer/notify",
  "/", // Homepage usually has its own footer or none
  "/refundpolicy",
  "/archidesign",
  "/housingplots",
  "/homeloan",
  "/support",
  "/constructionconsultation",
  "/landscaping",
  "/premiumconstruction",
  "/builder/jobs",
  "/properties",
  "/property/:id",
  // Note: `/master-data/:projectId` and `/upload-doc/:id` will be handled by the prefix check below
];

// MobileBottomNav moved to top import

const AppLayout = ({ children }) => {
  const location = useLocation();

  const isDynamicPathMatch = (pathPattern) => {
    // Example: pathPattern = "/master-data/" (matches /master-data/123)
    // Example: pathPattern = "/builder/project/" (matches /builder/project/66/payment)
    if (pathPattern.endsWith("/")) {
      // Ensure it's a prefix check
      return location.pathname.startsWith(pathPattern);
    }
    // For exact dynamic matches, you might need more complex logic or regex
    // For now, focusing on simple prefix matching for common dynamic routes
    const parts = pathPattern.split("/:");
    if (parts.length > 1 && location.pathname.startsWith(parts[0])) {
      return true;
    }
    return false;
  };

  const showNavbarFooter =
    !noNavbarFooterPaths.some((path) => {
      if (path.includes(":")) {
        // Handle dynamic route patterns
        return isDynamicPathMatch(path.split(":")[0]);
      }
      return location.pathname === path;
    }) &&
    !location.pathname.startsWith("/upload-doc/") && // Matches /upload-doc/ANYTHING
    !location.pathname.startsWith("/master-data/") && // Matches /master-data/ANYTHING
    !location.pathname.startsWith("/builder/project/") && // Matches /builder/project/ANYTHING (including /payment and /detail)
    !location.pathname.startsWith("/agent/housingpost/edit/") && // Hide navbar/footer on agent edit page
    !location.pathname.startsWith("/builder/housingplot/edit/") && // Hide navbar/footer on builder housing edit page
    !location.pathname.startsWith("/builder/propertypost/edit/") && // Hide navbar/footer on builder property edit page
    !location.pathname.startsWith("/reset-password"); // Keep this for reset password page

  // Define paths where MobileBottomNav should be hidden
  const hideMobileNavPaths = [
    "/agent",
    "/builder",
    "/customer",
    "/consultant",
    "/forgot-password",
    "/reset-password",
  ];

  const showMobileNav = !hideMobileNavPaths.some((path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  }) &&
    !location.pathname.startsWith("/master-data/");

  return (
    <div>
      {showNavbarFooter && <Navbarlanding />}
      {children}

      {/* Mobile Bottom Nav - Show on most pages except signup/login */}
      {showMobileNav && <MobileBottomNav />}
    </div>
  );
};

export default AppLayout;
